var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.636353 6.76805C0.694231 6.97774 0.788107 7.16431 0.976212 7.30531C1.13159 7.42074 1.32392 7.48399 1.52232 7.48488C1.72072 7.48578 1.91369 7.42428 2.07026 7.31026C2.13207 7.26406 2.19099 7.21455 2.24672 7.162C3.79391 5.715 5.34074 4.26746 6.88723 2.81937C6.93188 2.77054 6.98192 2.72627 7.03651 2.68728C7.06087 2.72823 7.0771 2.77677 7.11098 2.8088C8.6697 4.27142 10.2301 5.73317 11.7921 7.19403C12.0677 7.45192 12.3864 7.55099 12.7654 7.43872C13.3202 7.27361 13.5461 6.60691 13.197 6.17037C13.1575 6.12064 13.1142 6.07363 13.0675 6.0297C11.2686 4.34583 9.46953 2.66252 7.67035 0.979751C7.34179 0.672653 6.92464 0.611564 6.54949 0.818277C6.45891 0.872078 6.37591 0.936312 6.30245 1.00947C4.55456 2.64226 2.80703 4.2755 1.05985 5.90917C0.866102 6.09013 0.693172 6.2767 0.636353 6.53657L0.636353 6.76805Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.9c570a5ae22b2362ee3e35b622a3766e.svg";
export { ForwardRef as ReactComponent };